<template>
  <section
    id="our-reach"
    class="our-reach"
  >
    <div class="container">
      <h1 class="title">Elite professionals trust Proxify</h1>
      <p class="description">
        Gain support from our dedicated team, tailored-to-you career resources,
        and people-first culture.
      </p>
      <div class="numbers">
        <div>
          <span>3500+</span>
          <p>Members</p>
        </div>
        <div>
          <span>120+</span>
          <p>Nationalities</p>
        </div>
        <div>
          <span>230+</span>
          <p>Tech roles</p>
        </div>
        <div>
          <span>94%</span>
          <p>Recommended us</p>
        </div>
      </div>
      <div class="images">
        <div class="first-row">
          <div class="image-cover">
            <NuxtImg
              src="/images/our-reach/elipse.svg"
              class="ellipse"
              alt="ellipse"
            />
            <NuxtPicture
              class="image"
              src="/images/our-reach/image_1.png"
              alt="image1"
            />
          </div>
        </div>
        <div class="second-row">
          <div>
            <div class="image-cover">
              <NuxtImg
                class="ellipse"
                src="/images/our-reach/elipse.svg"
                alt="ellipse"
              />
              <NuxtPicture
                class="image"
                src="/images/our-reach/image_2.png"
                alt="image1"
              />
            </div>
          </div>
          <div>
            <div class="image-cover">
              <NuxtImg
                class="ellipse"
                src="/images/our-reach/elipse.svg"
                alt="ellipse"
              />
              <NuxtPicture
                class="image"
                src="/images/our-reach/image_3.png"
                alt="image1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <NuxtImg
      class="world"
      src="/images/our-reach/world.svg"
      alt="world"
    />
  </section>
</template>

<style lang="scss" scoped>
@import './OurReachSection.scss';
</style>
